export class OptanonNPAFlag {
    optanonInstance;

    constructor(optanonInstance) {
        this.optanonInstance = optanonInstance;
    }

    static getInstance(optanonInstance) {
        return new this(optanonInstance);
    }

    getNPAFlag() {
        return new Promise((resolve) => {
            this.optanonInstance.cmd.push((cmp) => {
                cmp.ads.getNpaFlag((flag) => {
                    resolve(flag);
                });
            });
        });
    }
}
